export default function FlagIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <path
        d="M7.93925 2.00049H5.14135C3.66049 2.00049 2.92008 2.00049 2.46004 2.43983C2 2.87917 2 3.58627 2 5.00049L2.0531 8.00049H7.93925C9.0508 8.00049 9.60655 8.00049 9.84235 7.71324C9.9076 7.63379 9.9554 7.54254 9.9828 7.44499C10.0819 7.09249 9.7485 6.66789 9.08155 5.81869C8.80415 5.46541 8.66545 5.28878 8.6407 5.08804C8.63355 5.02987 8.63355 4.9711 8.6407 4.91294C8.66545 4.71219 8.80415 4.53556 9.08155 4.18231C9.7485 3.33309 10.0819 2.90849 9.9828 2.55598C9.9554 2.45844 9.9076 2.3672 9.84235 2.28772C9.60655 2.00049 9.0508 2.00049 7.93925 2.00049Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 11.0005V4.50049"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}
